import React from 'react';
import PropTypes from 'prop-types';

import ExpandableList from "../ExpandableList";
import TrackStatusIcon from "../../Icons/TrackStatusIcon";
import { TRACK_STATUS_CLOSED, TRACK_STATUS_WAITING } from "../../../../config/constants";
import LegendBlockItemsList from "../LegendBlockItemsList";
import { t } from "../../../../lang/trans";
import { prepareTracksFromServerWaitingTracksToClient } from "../../../../helpers/map";
import { formatDate } from "../../../../helpers/common";

const LegendClosedTracksInfo = ({ isOpen, tracks, isWaiting, onToggle, onClickOnTrack }) => (
	<ExpandableList
		title={isWaiting ? t('зупинені[траси]', true) : t('закриті[траси]', true)}
		iconComponent={<TrackStatusIcon status={isWaiting ? TRACK_STATUS_WAITING : TRACK_STATUS_CLOSED} size={30}/>}
		isOpen={isOpen}
		onToggle={onToggle}
	>
		{tracks.map((tracksBlock, index) => (
			<React.Fragment key={tracksBlock.title + index}>
				<div className="legend-tracks-list-info-text">
					{tracksBlock.title}
					{tracksBlock.date && (
						<>
							— <span className='legend-tracks-list-date'>{formatDate(tracksBlock.date)}</span>
						</>
					)}
				</div>

				<LegendBlockItemsList
					tracks={prepareTracksFromServerWaitingTracksToClient(tracksBlock.tracks)}
					isClosed
					onClickOnTrack={trackId => onClickOnTrack(trackId)}
				/>
			</React.Fragment>
		))}
	</ExpandableList>
);

LegendClosedTracksInfo.propTypes = {
	isOpen: PropTypes.bool,
	tracks: PropTypes.array,
	onToggle: PropTypes.func,
	onClickOnTrack: PropTypes.func,
	isWaiting: PropTypes.bool
};

export default LegendClosedTracksInfo;
